import { motion } from "framer-motion";
import { useRef } from "react";

type BotAvatarValue = {
  isPreMade?: boolean;
  svgId?: number;
  url?: string;
};

type AgentAvatarPickerProps = {
  avatars: string[];
  botAvatar?: BotAvatarValue;
  onChange: (avatar: BotAvatarValue) => void;
  onUploadFile?: (file: File) => void;
  onUploadClick?: () => void;
  uploadRules?: React.ReactNode;
  className?: string;
};

const uploadIconUrl =
  "https://dlvkyia8i4zmz.cloudfront.net/LCPtGMwTQaaHG5Bf2RSD_Upload_icon.svg";
const tickIconUrl =
  "https://dlvkyia8i4zmz.cloudfront.net/nr7lZDM5T3ypnjdKAN9R_Group_14490.svg";
const removeIconUrl =
  "https://dlvkyia8i4zmz.cloudfront.net/1aMmB1VQKaY6fPnSGOUI_cross.svg";

const AgentAvatarPicker = ({
  avatars,
  botAvatar,
  onChange,
  onUploadFile,
  onUploadClick,
  uploadRules,
  className = "",
}: AgentAvatarPickerProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const uploadedAvatarUrl = botAvatar?.url ?? "";

  const handleUploadClick = () => {
    if (uploadedAvatarUrl) {
      onChange({
        isPreMade: false,
        svgId: 0,
        url: uploadedAvatarUrl,
      });
      return;
    }

    if (onUploadFile) {
      inputRef.current?.click();
      return;
    }

    onUploadClick?.();
  };

  return (
    <div className={`select-avatar w-100 p-[20px] ${className}`}>
      {onUploadFile && (
        <input
          ref={inputRef}
          className="hidden"
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (file) onUploadFile(file);
            event.target.value = "";
          }}
        />
      )}
      <div className="avatar-upload">
        <div className="preset-avatars">
          {avatars
            .map((avatarUrl, index) => ({
              avatarUrl,
              originalIndex: index,
              isActive:
                botAvatar?.isPreMade !== false &&
                index + 1 === (botAvatar?.svgId ?? 1),
            }))
            .map(({ avatarUrl, originalIndex, isActive }) => (
              <motion.div
                key={originalIndex}
                whileTap={{ scale: 0.9 }}
                className={`avatar-frame ${isActive ? "avatar-active" : ""}`}
                onClick={() => {
                  onChange({
                    isPreMade: true,
                    svgId: originalIndex + 1,
                    url: uploadedAvatarUrl,
                  });
                }}
              >
                {isActive && (
                  <img className="tick" src={tickIconUrl} alt="tick" />
                )}
                <img className="avatar-frame-img" src={avatarUrl} alt="" />
              </motion.div>
            ))}
        </div>
        <div className="upload-custom-avatar">
          <div
            className={`avatar-frame ${
              !botAvatar?.isPreMade ? "avatar-active" : ""
            }`}
            onClick={handleUploadClick}
          >
            <img
              className={`${
                uploadedAvatarUrl.trim()?.length > 0 ? "avatar-frame-img" : ""
              }`}
              src={
                uploadedAvatarUrl.trim()?.length > 0
                  ? uploadedAvatarUrl
                  : uploadIconUrl
              }
              alt=""
            />
            {uploadedAvatarUrl.trim()?.length > 0 && (
              <img className="tick" src={tickIconUrl} alt="tick" />
            )}

            <div
              className="remove-uploaded-avatar"
              onClick={(event) => {
                event.stopPropagation();
                onChange({
                  isPreMade: true,
                  svgId: 1,
                  url: "",
                });
              }}
            >
              <img src={removeIconUrl} alt="" />
            </div>
          </div>
        </div>
      </div>
      {uploadRules}
    </div>
  );
};

export default AgentAvatarPicker;
